import Loadable from '../../../../components/loadable';
import prerenderedLoadable from '../../../../components/prerender';

const Page =  Loadable(() =>
  import(/* webpackChunkName: "business-products-ba-1-on-1" */ './index')
);

export default prerenderedLoadable(Page);
